var map = {
	"./BitvoLoginPageBackground.webp": 1037,
	"./BitvoLogo.png": 1038,
	"./BitvoLogo_.jpg": 1039,
	"./BitvoUpp_Main.png": 1040,
	"./BitvouppApp.png": 1041,
	"./Google-Authenticator-icon.png": 1042,
	"./UPP_OTP.png": 1043,
	"./Upp_Login.png": 1044,
	"./Upp_Main.png": 1045,
	"./actionIcons/approve.png": 436,
	"./actionIcons/copyimg.png": 437,
	"./actionIcons/credential.png": 438,
	"./actionIcons/delete.png": 439,
	"./actionIcons/detail.png": 440,
	"./actionIcons/document.png": 441,
	"./actionIcons/download.png": 442,
	"./actionIcons/edit.png": 443,
	"./actionIcons/eft.png": 444,
	"./actionIcons/email.png": 445,
	"./actionIcons/etransfer.png": 446,
	"./actionIcons/explanantion.png": 447,
	"./actionIcons/information.png": 448,
	"./actionIcons/movetolegal.png": 449,
	"./actionIcons/pay.png": 450,
	"./actionIcons/print.png": 451,
	"./actionIcons/profile.png": 452,
	"./actionIcons/qrCode.png": 453,
	"./actionIcons/rowdetail.png": 454,
	"./actionIcons/signout.png": 455,
	"./actionIcons/submitorsend.png": 456,
	"./actionIcons/suspicious.png": 457,
	"./actionIcons/swift.png": 458,
	"./actionIcons/trace.png": 459,
	"./actionIcons/undo4.png": 460,
	"./actionIcons/unlock1.png": 461,
	"./actionIcons/unlock2.png": 462,
	"./actionIcons/upload.png": 463,
	"./actionIcons/verification.png": 464,
	"./actionIcons/wallet.png": 465,
	"./apple-icon.png": 1046,
	"./atm-edit.png": 822,
	"./atm-new.png": 823,
	"./atm.png": 824,
	"./baseline-notifications_none-24px.svg": 517,
	"./bitvoUppLogin.png": 1047,
	"./cheque.jpg": 1048,
	"./contactless.png": 1049,
	"./contactlessWhite.png": 1050,
	"./dcbank-feature-use.svg": 1051,
	"./dcbgnew.webp": 1052,
	"./face-template.png": 466,
	"./favicon.png": 1053,
	"./fcLogin.png": 1054,
	"./galerydefault-image.png": 215,
	"./h&rblock.png": 1055,
	"./id-card-back.png": 467,
	"./id-card.png": 468,
	"./id-template.png": 825,
	"./interac.png": 826,
	"./loginPageBackground.webp": 1056,
	"./logo-login.svg": 827,
	"./logo-white.svg": 518,
	"./logo.png": 346,
	"./logo.svg": 1057,
	"./logo_.jpeg": 1058,
	"./los-scorecard-value-table.png": 519,
	"./mastercard.png": 1059,
	"./mastercardBrand.png": 828,
	"./profile-female.png": 330,
	"./profile-male.png": 331,
	"./qr.png": 347,
	"./twilio-mark-red.png": 1060,
	"./uppApp.png": 1061,
	"./uppLogin.png": 1062,
	"./visaBrand.png": 829,
	"./visaimg.png": 1063,
	"./vrtbck.png": 1064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;